import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { fire } from "../firebase/config";
import Nanogram from "nanogram.js";

import "../assets/style/pay.css";

const instagramParser = new Nanogram();
function CreateAd() {
  const [swcButton1, setswcButton1] = useState(false);
  const [swcButton2, setswcButton2] = useState(false);
  const [dropMenu1, setDropMenu1] = useState(false);
  const [dropMenu2, setDropMenu2] = useState(false);
  const [dropMenu3, setDropMenu3] = useState(false);
  const [dropMenu4, setDropMenu4] = useState(false);
  const [dropMenu5, setDropMenu5] = useState(false);
  const [showLink, setshowLink] = useState(false);
  const [bargain, setBargain] = useState(false);
  const [coments, setComents] = useState(false);
  const [selectedContentType, setselectedContentType] = useState();
  const [
    selectedTransmissionMethod,
    setselectedTransmissionMethod,
  ] = useState();
  const [selectedVipPrice, setSelectedVipPrice] = useState(["1 неделю", 20]);
  const [selectedFixingPrice, setSelectedFixingPrice] = useState([
    "  2 недели",
    15,
  ]);
  const [payment, setPayment] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("Бизнес");
  const [newAd, setNewAd] = useState({});
  const [createError, setError] = useState();
  const [specialCode, setSpecialCode] = useState("");

  useEffect(() => {
    let result = "";
    let words = "0123456789qwertyuiopasdfghjklzxcvbnm";
    let max_position = words.length - 1;
    let position = 0;
    for (let i = 0; i < 7; ++i) {
      position = Math.floor(Math.random() * max_position);
      result = result + words.substring(position, position + 1);
    }

    setSpecialCode(result);
    return () => {};
  }, []);

  const telegramRequest = (link) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", `https://cors-anywhere.herokuapp.com/${link}`, true); // замените адрес
    xhr.send();

    xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) {
        return false;
      }

      if (xhr.status !== 200) {
        setError("please input valid link");
      } else {
        if (xhr.responseText.indexOf(specialCode) > 1) {
          let y = xhr.responseText.indexOf(`<div class="tgme_page_extra">`);
          let z = Number(y) + 29;
          let x = xhr.responseText.indexOf(`members`);
          let followers = xhr.responseText.substring(z, x);
          let a = xhr.responseText.indexOf(
            `<img class="tgme_page_photo_image" src="`
          );
          let b = Number(a) + 40;
          let c = xhr.responseText.indexOf(`"></a>`);
          let photo = xhr.responseText.substring(b, c);
          const ad = newAd;
          ad.followers = followers;
          ad.photo = photo;
          ad.verification = true;
          if (swcButton1 || swcButton2) {
            if (payment) {
              if (ad.verification) {
                firebaseAdd();
                return;
              }

              setError("Validation check error");
            }
            setError("oplata");
            return;
          }
        } else {
          setError("Validation check error");
        }
      }
    };
  };

  const okRequest = (link) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", `https://cors-anywhere.herokuapp.com/${link}`, true); // замените адрес
    xhr.send();

    xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) {
        return false;
      }

      if (xhr.status !== 200) {
        setError("please input valid link");
      } else {
        if (xhr.responseText.indexOf(specialCode) > 1) {
          let y = xhr.responseText.indexOf(`id="groupMembersCntEl"`);
          let tmp = xhr.responseText.substring(y);
          let x = tmp.indexOf(`</span>`);
          let z = tmp.substring(23, x);
          let k = z.replace("&nbsp;", "");

          let a = xhr.responseText.indexOf(`i.mycdn.me/i?`);
          let b = xhr.responseText.substring(a);
          let c = b.indexOf(`">`);
          let photo = b.substring(0, c);
          console.log(photo, k);
          const ad = newAd;
          ad.followers = k;
          ad.photo = "http://" + photo;
          ad.verification = true;
          if (swcButton1 || swcButton2) {
            if (payment) {
              if (ad.verification) {
                firebaseAdd();
                return;
              }

              setError("Validation check error");
            }
            setError("oplata");
            return;
          }
        } else {
          setError("Validation check error");
        }
      }
    };
  };

  const youtubeRequest = (link) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", `https://cors-anywhere.herokuapp.com/${link}`, true);
    xhr.send();

    xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) {
        return false;
      }

      if (xhr.status !== 200) {
        setError("please input valid link");
      } else {
        if (xhr.responseText.indexOf(specialCode) > 1) {
          let y = xhr.responseText.indexOf(
            `"subscriberCountText":{"runs":[{"text":"`
          );
          let z = xhr.responseText.substring(y + 40);
          let m = z.indexOf(`подписчиков`);
          let followers = z.substring(0, m);
          console.log(followers);

          let a = xhr.responseText.indexOf(`"avatar":{"thumbnails":[{"url":"`);
          let tmp = xhr.responseText.substring(a + 32);
          let b = tmp.indexOf(`","`);
          let photo = tmp.substring(0, b);
          console.log(photo);

          const ad = newAd;
          ad.followers = followers;
          ad.photo = photo;
          ad.verification = true;
          if (swcButton1 || swcButton2) {
            if (payment) {
              if (ad.verification) {
                firebaseAdd();
                return;
              }

              setError("Validation check error");
            }
            setError("oplata");
            return;
          }
        } else {
          setError("Validation check error");
        }
      }
    };
  };

  const ttRequest = (link) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", `https://cors-anywhere.herokuapp.com/${link}`, true);
    xhr.send();

    xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) {
        return false;
      }

      if (xhr.status !== 200) {
        setError("please input valid link");
      } else {
        if (xhr.responseText.indexOf(specialCode) > 1) {
          let tmp_html = xhr.responseText.substring(
            xhr.responseText.indexOf(`<meta name="renderer"`)
          );
          let y = tmp_html.indexOf(`| Лайки:`);
          let z = tmp_html.substring(y + 9);
          let m = z.indexOf(`Фанаты`);
          let followers = z.substring(0, m);
          console.log(followers);

          let a = xhr.responseText.indexOf(`property="og:image" content="`);
          let tmp = xhr.responseText.substring(a + 29);
          let b = tmp.indexOf(`"/>`);
          let photo = tmp.substring(0, b);
          console.log(photo);

          const ad = newAd;
          ad.followers = followers;
          ad.photo = photo;
          ad.verification = true;
          if (swcButton1 || swcButton2) {
            if (payment) {
              if (ad.verification) {
                firebaseAdd();
                return;
              }

              setError("Validation check error");
            }
            setError("oplata");
            return;
          }
        } else {
          setError("Validation check error");
        }
      }
    };
  };

  const fbRequest = (link) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", `https://cors-anywhere.herokuapp.com/${link}`, true);
    xhr.send();

    xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) {
        return false;
      }

      if (xhr.status !== 200) {
        setError("please input valid link");
      } else {
        if (xhr.responseText.indexOf(specialCode) > 1) {
          let y = xhr.responseText.indexOf(`Подписаны`);
          let z = Number(y) + 9;
          let x = xhr.responseText.indexOf(`человек`);
          let followers = xhr.responseText.substring(z, x);

          let a = xhr.responseText.indexOf(
            `img class="scaledImageFitHeight img"`
          );
          let tmp = xhr.responseText.substring(a);
          let b = tmp.indexOf(`" data-src`);
          let find = "amp;";
          let re = new RegExp(find, "g");
          let photo = tmp.substring(42, b);
          let txt = photo.replace(re, "");
          console.log(txt, followers);
          const ad = newAd;
          ad.followers = followers;
          ad.photo = photo;
          ad.verification = true;
          if (swcButton1 || swcButton2) {
            if (payment) {
              if (ad.verification) {
                firebaseAdd();
                return;
              }

              setError("Validation check error");
            }
            setError("oplata");
            return;
          }
        } else {
          setError("Validation check error");
        }
      }
    };
  };

  const instaRequest = (groupId) => {
    console.log(groupId);
    instagramParser.getMediaByUsername(groupId).then((media) => {
      const ad = newAd;
      console.log(media);
      ad.followers = media.profile.edge_followed_by.count;
      ad.photo = media.profile.profile_pic_url;
      ad.verification =
        media.profile.biography.indexOf(specialCode) >= 0 ? true : false;
      setNewAd(ad);
      if (swcButton1 || swcButton2) {
        if (payment) {
          if (ad.verification) {
            firebaseAdd();
            return;
          }

          setError("Validation check error");
        }
        setError("oplata");
        return;
      }
      if (ad.verification) {
        firebaseAdd();
        return;
      }

      setError("Validation check error");

      return;
    });
  };

  const handleChange = (e) => {
    let tmp = newAd;
    tmp[e.target.name] = e.target.value;
    setNewAd(newAd);
    console.log(newAd);
    let db = {};
  };

  const handleCheckbox = (e) => {
    if (e.target.name === "coments") {
      setComents(e.target.value);
    }
    if (e.target.name === "bargain") {
      setBargain(e.target.value);
    }
    if (e.target.name === "link") {
      setshowLink(e.target.value);
    }
  };

  const vkRequest = (groupId) => {
    let proxyUrl = "https://cors-anywhere.herokuapp.com/";
    let url = `https://api.vk.com/method/groups.getById?access_token=029c7f439b71f91539435909c824ae16cae3152e3e6ed5414b604035e7d30655251f9ccb87d6264f8d751&v=5.120&group_id=${groupId}&fields=description,members_count`;
    let x = fetch(proxyUrl + url).then((res) => {
      return res.json();
    });
    x.then((response) => {
      const ad = newAd;

      ad.followers = response.response[0].members_count;
      ad.photo = response.response[0].photo_100;
      ad.verification =
        response.response[0].description.indexOf(specialCode) >= 0
          ? true
          : false;
      setNewAd(ad);
      if (swcButton1 || swcButton2) {
        if (payment) {
          if (true) {
            ////////
            firebaseAdd();
            return;
          }

          setError("Validation check error");
        }
        setError("oplata");
        return;
      }
      if (ad.verification) {
        firebaseAdd();
        return;
      }
      console.log(
        response.response[0].description.indexOf(specialCode),
        response.response[0].description,
        response.response[0].description === specialCode
      );

      setError("Validation check error");

      return;
    });
  };

  const firebaseAdd = () => {
    const ad = newAd;
    ad.ownerId = fire.auth().currentUser.uid;
    if (swcButton1) {
      ad.vip = selectedVipPrice;
    }
    if (swcButton2) {
      ad.fix = selectedFixingPrice;
    }
    ad.contentType = selectedContentType;
    ad.selectedCategory = selectedCategory;
    ad.selectedTransmissionMethod = selectedTransmissionMethod;
    ad.category = selectedCategory;
    ad.createdData = JSON.stringify(new Date());
    ad.link = showLink;
    ad.bargain = bargain;
    ad.coments = coments;

    let id = "";
    let db = [];
    fire
      .database()
      .ref("/ad")
      .once("value")
      .then((snapshot) => {
        db = snapshot.val();
        id = Object.keys(db).length;
        fire
          .database()
          .ref("/ad/" + id)
          .set(ad)
          .then(() => {
            fire
              .database()
              .ref("/users/" + ad.ownerId + "/ad/")
              .push({ id });
          });
      });
  };

  const submitAd = async () => {
    if (
      newAd.link.indexOf("ok") > 0 ||
      newAd.link.indexOf("odnoklassniki") > 0
    ) {
      await okRequest(newAd.link);
    }
    if (newAd.link.indexOf("fb") > 0 || newAd.link.indexOf("facebook") > 0) {
      await fbRequest(newAd.link);
    }
    if (newAd.link.indexOf("tt") > 0 || newAd.link.indexOf("tiktok") > 0) {
      await ttRequest(newAd.link);
    }
    if (newAd.link.indexOf("youtube") > 0) {
      await youtubeRequest(newAd.link);
    }
    if (newAd.link.indexOf("vk.com") > 0) {
      await vkRequest(newAd.link.slice(newAd.link.indexOf("vk.com/") + 7));
    }
    if (newAd.link.indexOf("instagram.com") > 0) {
      await instaRequest(
        newAd.link.slice(newAd.link.indexOf("instagram.com/") + 14)
      );
    }
    if (newAd.link.indexOf("t.me") > 0 || newAd.link.indexOf("telegram") > 0) {
      await telegramRequest(newAd.link);
    }
  };
  return (
    <section class="new">
      <Container>
        <Row>
          <div class="col-lg-11 m-auto">
            <div class="new__wrapper">
              <div class="new__title">Новое объявление</div>
              <div class="new__form">
                <div class="new-form__title">
                  <h3>Основная информация</h3>
                </div>
                <div class="new-form__petch d-flex">
                  <div class="new-form-petch__item">
                    <h3>Ссылка на сообщество</h3>
                    <input
                      type="text"
                      name="link"
                      class="soobsh"
                      onChange={handleChange}
                    />
                  </div>
                  <div class="new-form-petch__item">
                    <h3>Цена</h3>
                    <input
                      type="text"
                      name="price"
                      class="new__price"
                      onChange={handleChange}
                    />
                  </div>
                  <div class="new-form-petch__item">
                    <h3>Тематика</h3>

                    <div class="dropdown1">
                      <button
                        class={
                          dropMenu1
                            ? "search-item__vp10 drop-active"
                            : "search-item__vp10"
                        }
                        onClick={() => {
                          setDropMenu1(() => !dropMenu1);
                        }}
                      >
                        {selectedCategory}
                        <div class="dropdown-child">
                          <a onClick={() => setSelectedCategory("Подраздел 1")}>
                            Подраздел 1
                          </a>
                          <a onClick={() => setSelectedCategory("Подраздел 2")}>
                            Подраздел 2
                          </a>
                          <a onClick={() => setSelectedCategory("Подраздел 3")}>
                            Подраздел 3
                          </a>
                          <a onClick={() => setSelectedCategory("Подраздел 4")}>
                            Подраздел 4
                          </a>
                          <a onClick={() => setSelectedCategory("Подраздел 5")}>
                            Подраздел 5
                          </a>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="new-form__info">
                  <input
                    type="text"
                    name="name"
                    onChange={handleChange}
                    class="input-new"
                    placeholder="Краткое описание"
                  />
                </div>
                <div class="new-form__texta">
                  <textarea
                    name="description"
                    class="new-form-info"
                    onChange={handleChange}
                    placeholder="Полное описание"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </Row>
        <div class="row">
          <div class="m-auto col-lg-11">
            <div class="new__info">
              <div class="new-info__title">
                <h2>Продай быстрее</h2>
              </div>
              <div class="new-info__subtitle">
                <p>
                  Выберите одну или обе услуги и продайте вашу группу или
                  страничку еще быстрее!
                </p>
                <p>
                  Благодаря пакету услуг ваше объявление будет всегда на виду и
                  выделяться цветом среди других объявлений. Вы продадите группу
                  максимально быстро!
                </p>
              </div>
            </div>
            <div class="new-info-obwbox d-flex">
              <div class="new-info__obw">
                <div class="new-info__box d-flex">
                  <div class="new-info-obw__title">VIP закрепеление</div>
                  <div class="switch__box">
                    <div
                      class={swcButton1 ? "switch-btn switch-on" : "switch-btn"}
                      onClick={() => {
                        setswcButton1(() => !swcButton1);
                      }}
                    ></div>
                  </div>
                </div>

                <div class="dropdown1">
                  <button
                    class={
                      dropMenu2
                        ? "search-item__vp10 drop-active"
                        : "search-item__vp10"
                    }
                    onClick={() => {
                      setDropMenu2(() => !dropMenu2);
                    }}
                  >
                    {selectedVipPrice[0]}
                    <div class="dropdown-child">
                      <a
                        onClick={() => setSelectedVipPrice(["Подраздел 1", 20])}
                      >
                        Подраздел 1
                      </a>
                      <a
                        onClick={() => setSelectedVipPrice(["Подраздел 2", 40])}
                      >
                        Подраздел 2
                      </a>
                      <a
                        onClick={() => setSelectedVipPrice(["Подраздел 3", 60])}
                      >
                        Подраздел 3
                      </a>
                      <a
                        onClick={() => setSelectedVipPrice(["Подраздел 4", 80])}
                      >
                        Подраздел 4
                      </a>
                      <a
                        onClick={() => setSelectedVipPrice(["Подраздел 5", 80])}
                      >
                        Подраздел 5
                      </a>
                    </div>
                  </button>
                </div>

                <div class="new-info__ps d-flex">
                  <div class="new-info__price">{selectedVipPrice[1]}$</div>
                  <div class="new-info__seems">Просмотр x4</div>
                </div>
              </div>
              <div class="new-info__obw">
                <div class="new-info__box d-flex">
                  <div class="new-info-obw__title">Закрепление объявления</div>
                  <div class="switch__box">
                    <div
                      class={swcButton2 ? "switch-btn switch-on" : "switch-btn"}
                      onClick={() => {
                        setswcButton2(() => !swcButton2);
                      }}
                    ></div>
                  </div>
                </div>
                <div class="dropdown1">
                  <button
                    class={
                      dropMenu3
                        ? "search-item__vp10 drop-active"
                        : "search-item__vp10"
                    }
                    onClick={() => {
                      setDropMenu3(() => !dropMenu3);
                    }}
                  >
                    {selectedFixingPrice[0]}
                    <div class="dropdown-child">
                      <a
                        onClick={() =>
                          setSelectedFixingPrice(["Подраздел 1", 20])
                        }
                      >
                        Подраздел 1
                      </a>
                      <a
                        onClick={() =>
                          setSelectedFixingPrice(["Подраздел 2", 40])
                        }
                      >
                        Подраздел 2
                      </a>
                      <a
                        onClick={() =>
                          setSelectedFixingPrice(["Подраздел 3", 60])
                        }
                      >
                        Подраздел 3
                      </a>
                      <a
                        onClick={() =>
                          setSelectedFixingPrice(["Подраздел 4", 80])
                        }
                      >
                        Подраздел 4
                      </a>
                      <a
                        onClick={() =>
                          setSelectedFixingPrice(["Подраздел 5", 80])
                        }
                      >
                        Подраздел 5
                      </a>
                    </div>
                  </button>
                </div>
                <div class="new-info__ps d-flex">
                  <div class="new-info__price">{selectedFixingPrice[1]}$</div>
                  <div class="new-info__seems">Просмотр x6</div>
                </div>
              </div>
            </div>
            <div class="new__pay d-flex">
              <div class="new-pay__item new-pay-item d-flex">
                <div class="new-pay-item__title">
                  <h4>Сумма</h4>
                </div>
                <div class="new-pay-item__sum">
                  {selectedFixingPrice[1] + selectedVipPrice[1]}$
                </div>
              </div>
              <div class="new-pay__item new-pay-item d-flex">
                <div class="new-pay-item__title">
                  <h4>Споcоб оплаты</h4>
                </div>
                <div class="new-pay-item__pays new-pays d-flex">
                  <div class="new-pays__item">
                    <a href="#">
                      <img src="img/pay1.png" alt="icon" />
                    </a>
                  </div>
                  <div class="new-pays__item">
                    <a href="#">
                      <img src="img/pay2.png" alt="icon" />
                    </a>
                  </div>
                  <div class="new-pays__item">
                    <a href="#">
                      <img src="img/pay3.png" alt="icon" />
                    </a>
                  </div>
                  <div class="new-pays__item">
                    <a href="#">
                      <img src="img/pay4.png" alt="icon" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="new__more">
              <h2>Дополнительная информация</h2>

              <div class="fp d-flex">
                <div class="fp__item">
                  <div class="fp-item__title">Тип контента</div>

                  <div class={dropMenu4 ? "drop-active" : null}>
                    <button
                      class="search-item__vp1"
                      onClick={() => {
                        setDropMenu4(() => !dropMenu4);
                      }}
                    >
                      Выбрать
                      <div class="dropdown-child">
                        <a
                          onClick={() => setselectedContentType("Подраздел 1")}
                        >
                          Подраздел 1
                        </a>
                        <a
                          onClick={() => setselectedContentType("Подраздел 2")}
                        >
                          Подраздел 2
                        </a>
                        <a
                          onClick={() => setselectedContentType("Подраздел 3")}
                        >
                          Подраздел 3
                        </a>
                        <a
                          onClick={() => setselectedContentType("Подраздел 4")}
                        >
                          Подраздел 4
                        </a>
                        <a
                          onClick={() => setselectedContentType("Подраздел 5")}
                        >
                          Подраздел 5
                        </a>
                      </div>
                    </button>
                  </div>
                </div>
                <div class="fp__item">
                  <div class="fp-item__title">Способ передачи сообщества</div>
                  <div class={dropMenu5 ? "drop-active" : null}>
                    <button
                      class="search-item__vp1"
                      onClick={() => {
                        setDropMenu5(() => !dropMenu5);
                      }}
                    >
                      Выбрать
                      <div class="dropdown-child">
                        <a
                          onClick={() =>
                            setselectedTransmissionMethod("Подраздел 1")
                          }
                        >
                          Подраздел 1
                        </a>
                        <a
                          onClick={() =>
                            setselectedTransmissionMethod("Подраздел 2")
                          }
                        >
                          Подраздел 2
                        </a>
                        <a
                          onClick={() =>
                            setselectedTransmissionMethod("Подраздел 3")
                          }
                        >
                          Подраздел 3
                        </a>
                        <a
                          onClick={() =>
                            setselectedTransmissionMethod("Подраздел 4")
                          }
                        >
                          Подраздел 4
                        </a>
                        <a
                          onClick={() =>
                            setselectedTransmissionMethod("Подраздел 5")
                          }
                        >
                          Подраздел 5
                        </a>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              <div class="ft d-flex">
                <div class="ft-item">
                  <div class="ft-item__title">Доход в месяц</div>
                  <input
                    type="text"
                    class="ft-item__input"
                    name="amount"
                    onChange={handleChange}
                  />
                </div>
                <div class="ft-item">
                  <div class="ft-item__title">Источник доходов</div>
                  <input
                    type="text"
                    class="ft-item__input inp2"
                    name="sourceOfIncome"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div class="ft d-flex">
                <div class="ft-item">
                  <div class="ft-item__title">Расходы</div>
                  <input
                    type="text"
                    class="ft-item__input"
                    name="expenses"
                    onChange={handleChange}
                  />
                </div>
                <div class="ft-item">
                  <div class="ft-item__title">Источник расходов</div>
                  <input
                    type="text"
                    class="ft-item__input inp2"
                    name="sourceOfExpenses"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div class="ff">
                <div class="ft-item__title">Способы ракрутки группы</div>
                <input
                  type="text"
                  class="ffinp"
                  name="promotion"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div class="new__morer">
              <h2>Верификация</h2>
              <p>
                Разместите код в статусе или описании вашего сообщества, для
                Instagram в поле "О себе", для подтверждения прав
                администрирования.
              </p>
              <p>Удалить код можно сразу после публикации.</p>
              <div class="new-morer__code d-flex">
                <div class="new-code__link">{specialCode}</div>
                <div class="new-code__copy">
                  <a href="#">Скопировать код</a>
                </div>
              </div>
            </div>
            <form action="#" class="newch-box">
              <input
                type="checkbox"
                id="newch"
                onChange={handleCheckbox}
                name="link"
              />
              <label for="newch">Отображать ссылку</label>
              <input
                type="checkbox"
                id="newch1"
                onChange={handleCheckbox}
                name="bargain"
              />
              <label for="newch1">Торг</label>
              <input
                type="checkbox"
                id="newch2"
                onChange={handleCheckbox}
                name="coments"
              />
              <label for="newch2">Разрешить комментировать объявление</label>
            </form>
            <span>{createError}</span>
            <div class="new-check__btn">
              <a onClick={submitAd}>Запустить</a>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default CreateAd;
